import { CSSProperties, ReactNode } from 'react';

const FlexContainer = ({
  children,
  style
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => (
  <div className="flex-container" style={style}>
    {children}

    <style jsx>{`
      .flex-container {
        align-items: center;
        display: flex;
        justify-content: flex-start;
      }
    `}</style>
  </div>
);

export default FlexContainer;
